// extracted by mini-css-extract-plugin
export default {"richtext":"styles_richtext__6166I"};